<ng-select #ngSelect
           [(ngModel)]="value"
           [items]="items"
           [bindLabel]="bindLabel"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [style.width]="width"
           [multiple]="true"
           [searchable]="false"
           [closeOnSelect]="false"
           [clearable]="false"
           (open)="onOpen()"
           class="lib-multi-select">
    <ng-template ng-multi-label-tmp>
        <div *ngIf="getSelectedItems().length > 0" class="selected-display">
            <span>{{ getSelectedItems()[0][bindLabel] }}</span>
            <span *ngIf="getSelectedItems().length > 1"> (+{{ getSelectedItems().length - 1 }} more)</span>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div class="option-item"
             tabindex="0"
             role="option"
             [attr.aria-selected]="isSelected(item)"
             (click)="toggleItem(item, $event)"
             (keydown.enter)="toggleItem(item, $event)">
            <input type="checkbox" [checked]="isSelected(item)" (click)="toggleItem(item, $event)"/>
            <span>{{ item[bindLabel] }}</span>
        </div>
    </ng-template>
    <ng-template ng-footer-tmp>
        <div class="modal-footer dropdown-footer">
            <button type="button" class="btn btn-sm btn-primary" (click)="apply($event)">Apply</button>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="clear($event)">Clear</button>
        </div>
    </ng-template>
</ng-select>
